import React, { useEffect, useState } from "react"

import { Col, Divider, Modal, Row, Select, Spin } from "antd";

import { VisualizarDocumentoHTML } from "@/Documentos/VisualizarDocumentoHTML";
import { useObterHTMLDaFichaDeAutorizacaoDoAluno } from "@/Services/Domain/Documentos/DocumentoService";
import Button from "antd/lib/button";
import { HttpStatusCode } from "axios";
import { TypeAluno } from "@/Models/Domain/Pessoa/Aluno";
import FormItem from "antd/es/form/FormItem";

export const AutorizacaoDaViagem: React.FC<
    (
        | { privilegio: "escola", codigoDaViagem: number, aluno: TypeAluno }
        | { privilegio: "responsavel", codigoDoAluno: number, codigoDaViagem: number }
    )
> = (props) => {

    const [filtro, setFiltro] = useState<Parameters<typeof useObterHTMLDaFichaDeAutorizacaoDoAluno>[1][0] | undefined>();

    const htmlQuery = useObterHTMLDaFichaDeAutorizacaoDoAluno({ enabled: false }, [
        filtro!,
        {
            doNotNotify: (err) => err.response?.status === HttpStatusCode.NotFound,
        },
    ]);

    
    useEffect(() => {
        htmlQuery.refetch();
    }, [filtro])

    useEffect(() => {
        if(props.privilegio == "responsavel"){
            setFiltro({
                codigoDaViagem: props.codigoDaViagem,
                codigoDoAluno: props.codigoDoAluno
            })
        } else {
            if(props.aluno.codigo === undefined) return;
            const codResponsavel = props.aluno.responsaveis?.filter((rel) => rel.principal === true).at(0)?.responsavel.codigo;
            if (!codResponsavel) return;

            setFiltro({ codigoDaViagem: props.codigoDaViagem, codigoDoAluno: props.aluno.codigo, codigoDoResponsavel: codResponsavel });

        }
    }, [])

    const aoSelecionarResponsavel = (codigo: number) => {
        if(props.privilegio !== "escola") return;
        if(props.aluno.codigo === undefined) return;

        if (filtro) {
            setFiltro({ ...filtro, codigoDoResponsavel: codigo });
        } else {
            setFiltro({ codigoDaViagem: props.codigoDaViagem, codigoDoAluno: props.aluno.codigo, codigoDoResponsavel: codigo });
        }
    };

    const html = htmlQuery.data?.data;

    return (
        <React.Fragment>
            <Spin spinning={htmlQuery.isFetching}>
                <Row gutter={[16, 16]}>
                    {props.privilegio === "escola" && (
                        <Col xs={24}>
                            <FormItem labelCol={{ span: 24 }} label={<>Responsável</>}>
                                <Select
                                    value={filtro?.codigoDoResponsavel}
                                    onChange={(aoSelecionarResponsavel)}
                                    options={props.aluno.responsaveis?.map((rel) => ({
                                        label: rel.responsavel.pessoa?.nome,
                                        value: rel.responsavel.codigo,
                                    }))}
                                />
                            </FormItem>
                        </Col>
                    )}

                    <Col xs={24}>{html && <VisualizarDocumentoHTML html={html} />}</Col>
                </Row>
            </Spin>
        </React.Fragment>
    );
};

export const AutorizacaoDaViagemModal: React.FC<{
    autorizacaoProps: { codigoDoAluno?: number | undefined } & React.ComponentProps<typeof AutorizacaoDaViagem>;
    buttonOpen: React.ReactNode;
}> = ({ buttonOpen, ...props }) => {
    const [aberta, setAberta] = useState<boolean>(false);

    return (
        <>
            {(buttonOpen && React.cloneElement(buttonOpen as React.ReactElement<any>, { onClick: () => setAberta(true) })) || (
                <Button type="primary" size="small" onClick={() => setAberta(true)}>
                    Autorização da viagem
                </Button>
            )}

            <Modal
                destroyOnClose
                width={"80vw"}
                title="Autorização da viagem"
                maskClosable={false}
                open={aberta}
                footer={(_, { OkBtn }) => (
                    <>
                        <OkBtn />
                    </>
                )}
                onOk={() => {
                    setAberta(false);
                }}
                onCancel={() => {
                    setAberta(false);
                }}
            >
                <Divider/>
                {props.autorizacaoProps ? <AutorizacaoDaViagem {...props.autorizacaoProps} /> : <></>}
            </Modal>
        </>
    );
};